import * as angular from "angular";
import {IController} from "angular";
import {AgentModel} from "../../angular/models/agent.model";
import {LogisticsVehicle} from "../../../logistics-vehicle/models/logistics-vehicle.model";

export class AgentAssignTableRowCtrl implements IController {

  agent: AgentModel;
  columns: any;
  logisticsVehiclesList: LogisticsVehicle[]
  score: any;
  availableSchedules: any;
  contractPrice: string;
  isLinkedAgent: boolean;
  isIgnoreScore: boolean;

  onAssign: Function;

  private isDesktop: any;

  constructor(private $mdMedia) {

  }

  $onInit() {
    this.isDesktop = this.$mdMedia('gt-sm');
  }
}

angular
  .module('bringoz.admin.agents')
  .component('agentAssignTableRow', {
    bindings: {
      agent: '<',
      columns: '<',
      logisticsVehiclesList: '<',
      score: '<',
      availableSchedules: '<',
      contractPrice: '<',
      isLinkedAgent: '<?',
      isIgnoreScore: '<?',
      onAssign: '&'
    },
    template: require('./agent-assign-table-row.html').default,
    controller: AgentAssignTableRowCtrl
  });
